import { render, staticRenderFns } from "./real-stories.vue?vue&type=template&id=3cb519ae&scoped=true"
import script from "./real-stories.vue?vue&type=script&lang=js"
export * from "./real-stories.vue?vue&type=script&lang=js"
import style0 from "./real-stories.vue?vue&type=style&index=0&id=3cb519ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb519ae",
  null
  
)

export default component.exports